import router from '@/router';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('AdminPanelCtrl', adminPanelCtrl);

    function adminPanelCtrl($scope) {
        $scope.router = router;
    }
})();
